import {
  destroyCookie as destroyCookieWithNookies,
  parseCookies,
  setCookie as setCookieWithNookies,
} from 'nookies';
import { ONE_WEEK_IN_SECONDS } from './date';

export const setCookie = (
  key: string,
  value: string,
  expires_in = ONE_WEEK_IN_SECONDS
) =>
  setCookieWithNookies(undefined, key, value, {
    maxAge: expires_in,
    path: '/',
  });

export const getAllCookies = (context?: ParseCookiesContext) =>
  parseCookies(context);

export const getCookie = (key: string) => {
  const cookies = parseCookies();
  return cookies[key];
};

export const destroyCookie = (key: string) =>
  destroyCookieWithNookies(null, key);

export type ParseCookiesContext = Parameters<typeof parseCookies>[0];
